import { gql } from '@apollo/client/core'

export const GREFFE_EXPORT = gql`
  mutation greffeExportSend($startingDate: ISO8601DateTime!, $endingDate: ISO8601DateTime!){
    greffeExportSend(startingDate: $startingDate, endingDate: $endingDate){
      result { 
        status 
        message
      }
    }
  }
`

export interface GreffeExportVariables {
  startingDate: string,
  endingDate: string
}

export interface GreffeExportResult {
  result: {
    message: string,
    status: string
  }
}
